module.exports = __webpack_public_path__ + "static/img/luther-univ.326692d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/luther-univ.jpg
// module id = Ggu6
// module chunks = 0